import { useEffect } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useAmplitude } from 'hooks/useAmplitude';
import { usePhoneNumber } from 'hooks/usePhoneNumber';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './ChecksRequired.module.css';

export const ChecksRequired = () => {
  const { trackEvent } = useAmplitude();
  const { introducerType } = useIntroducerData();
  const isAccountant = introducerType === 'accountant';
  const { phoneNumberLink } = usePhoneNumber();

  useEffect(() => {
    trackEvent(AMPLITUDE_EVENTS.checksRequiredShown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const introducerEmail = isAccountant
    ? t`accountants@iwoca.co.uk`
    : t`brokers@iwoca.co.uk`;

  return (
    <div className={styles.checksRequiredContainer}>
      <h2 className={styles.heading}>
        <Trans>We have received your application</Trans>
      </h2>
      <p className={styles.text}>
        <Trans>
          We're running some required checks. Please{' '}
          <a
            href={`mailto:${introducerEmail}`}
            data-testid="email-link"
            onClick={() => {
              trackEvent(AMPLITUDE_EVENTS.contactLinkClicked, {
                'CTA location': 'Checks required',
                'CTA destination': 'Email us',
                'CTA text': 'Email us',
                'CTA URL': `mailto:${introducerEmail}`,
              });
            }}
          >
            email
          </a>{' '}
          or{' '}
          <a
            href={`tel:${phoneNumberLink}`}
            data-testid="call-link"
            onClick={() => {
              trackEvent(AMPLITUDE_EVENTS.contactLinkClicked, {
                'CTA location': 'Checks required',
                'CTA destination': 'Call us',
                'CTA text': 'Call us',
                'CTA URL': `tel:${phoneNumberLink}`,
              });
            }}
          >
            call
          </a>{' '}
          our introducer team for further information.
        </Trans>
      </p>
    </div>
  );
};
